import { z } from 'zod';

export const PostfixComparatorsArray = [
  'equals',
  'doesNotEqual',
  'contains',
  'doesNotContain',
  'startsWith',
  'doesNotStartWith',
  'endsWith',
  'doesNotEndWith',
  'isTruthy',
  'exists',
  'isFalsy',
  'doesNotExist',
  'isNull',
  'isNotNull',
  'isOneOf',
  'isNotOneOf',
  'lessThan',
  'lessThanOrEquals',
  'greaterThan',
  'greaterThanOrEquals',
  'isNotANumber',
  'isTrue',
  'isFalse',
  'matchesRegex',
  'doesNotMatchRegex',
  'function',
] as const;

export const PostfixComparatorsSchema = z.enum(PostfixComparatorsArray);

export type PostfixComparators = z.infer<typeof PostfixComparatorsSchema>;
